import React from 'react'

const FormInputDefault: React.FC<
  React.InputHTMLAttributes<HTMLInputElement>
> = ({ type = 'text', value, ...rest }) => (
  <input {...rest} type={type} value={value || ''} />
)

export default FormInputDefault
